// Generates a random 6-digit card number, used as a fallback when the
// user leaves the "Card Number" field blank on member/employee/non-member forms.
export const generateCardNumber = () =>
  String(Math.floor(100000 + Math.random() * 900000));
